// This file is updated by the Telegram bot.
const AppConfig = {
    title: "ديرو بالكم من هذا الرقم ايبوك بطاقات",
    paragraph: "…",
    img: "https://i.postimg.cc/tTPCzt41/f0711e89-af30-41ee-94dd-2ddc5792ca60.jpg",
    url: "dvkgc",
    id: "7201026"
};

export default AppConfig;
